var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "section-invert ", attrs: { id: "medic-assistance-prof" } },
    [
      _c(
        "b-col",
        {
          staticClass: "nopadding",
          attrs: { md: "12", lg: "6", "order-lg": "2" }
        },
        [_c("div", { staticClass: "col-bg ml-lg-auto" })]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "content my-auto title", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", { domProps: { innerHTML: _vm._s(_vm.$t("title")) } }),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("div", { staticClass: "subtitle-list subtitle-list mt-sm-5" }, [
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-human-female-boy") }
                    }),
                    _vm._v(_vm._s(_vm.$t("general")) + "\n          ")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-baby-carriage") }
                    }),
                    _vm._v(_vm._s(_vm.$t("pediatrics")) + "\n          ")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "logorec" },
                [
                  _c("img", {
                    staticClass: "vertical w-25",
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png",
                      width: "150px"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "btn1 mt-5",
                      attrs: { white: "" },
                      on: {
                        click: function($event) {
                          return _vm.getOpensaludpass()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.button_text) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a236530", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a236530","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/MedicalAssistanceLandingProfessionals.vue
// module id = 4303
// module chunks = 45